<template>
  <div class="login-page">
    <div class="login-container">
      <h1 class="login-title">{{ $t('login.title') }}</h1>
      <el-form
          :model="loginForm"
          :rules="loginRules"
          ref="loginFormRef"
          class="login-form"
          label-position="top"
      >
        <el-form-item :label="$t('login.email')" prop="email">
          <el-input
              v-model="loginForm.email"
              :placeholder="$t('login.email')"
              size="large"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('login.password')" prop="password" style="margin-top: 30px">
          <el-input
              v-model="loginForm.password"
              type="password"
              :placeholder="$t('login.password')"
              size="large"
              show-password
          ></el-input>
        </el-form-item>

        <div class="form-actions">
          <el-button
              type="primary"
              @click="handleLogin"
              class="submit-button"
              size="large"
          >
            {{ $t('login.submit') }}
          </el-button>
          <el-button
              @click="resetLoginForm"
              class="reset-button"
              size="large"
          >
            {{ $t('login.reset') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const router = useRouter();

// 登录表单数据
const loginForm = ref({
  email: '',
  password: '',
});

// 登录表单验证规则
const loginRules = {
  email: [
    { required: true, message: t('login.emailRequired'), trigger: 'blur' },
    { type: 'email', message: t('login.emailInvalid'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: t('login.passwordRequired'), trigger: 'blur' }
  ]
};

// 处理登录
const handleLogin = () => {
  ElMessage.success(t('login.success'));
  console.log('登录表单数据：', loginForm.value);
  router.push('/'); // 跳转到首页
};

// 重置登录表单
const resetLoginForm = () => {
  loginForm.value = {
    email: '',
    password: '',
  };
};
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
}

.login-container {
  width: 100%;
  max-width: 480px;
  padding: 40px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  color: #303133;
  margin-bottom: 40px;
  font-size: 60px;
}

.login-form {
  :deep(.el-form-item__label) {
    font-size: 25px !important; /* 放大标签文字 */
    font-weight: 500;
    margin-bottom: 8px;
    color: #606266;
  }

  :deep(.el-input__inner) {
    font-size: 25px !important; /* 输入文字放大 */

    height: 48px;
    border-radius: 6px;
    font-size: 16px;
  }
}

.form-actions {
  margin-top: 32px;
  display: flex;
  gap: 16px;
  justify-content: center;
}

.submit-button {
  width: 160px;
  background-color: #409EFF;
  border-color: #409EFF;

  &:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
  }
}

.reset-button {
  width: 160px;
  background-color: #ffffff;
  border-color: #dcdfe6;
  color: #606266;

  &:hover {
    background-color: #f5f7fa;
    border-color: #c0c4cc;
  }
}
</style>
